export default __webpack_public_path__ + "static/media/security.54deb419.svg";